
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"13","height":"13"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_22631","data-name":"Group 22631","transform":"translate(-1 -2)"}},[_c('g',{attrs:{"id":"Group_22516","data-name":"Group 22516","transform":"translate(1 2.619)"}},[_c('path',{attrs:{"id":"Path_19240","data-name":"Path 19240","d":"M11.524 15.381H2.857A1.859 1.859 0 011 13.524V4.857A1.859 1.859 0 012.857 3h4.952a.619.619 0 010 1.238H2.857a.62.62 0 00-.619.619v8.667a.62.62 0 00.619.619h8.667a.62.62 0 00.619-.619V8.571a.619.619 0 111.238 0v4.952a1.859 1.859 0 01-1.857 1.858z","transform":"translate(-1 -3)","fill":"#6b7786"}})]),_c('path',{attrs:{"id":"Path_19241","data-name":"Path 19241","d":"M16.285 1h-3.142a.524.524 0 00-.37.894l1.2 1.2-3.82 3.82a.524.524 0 10.741.741l3.82-3.82 1.2 1.2a.524.524 0 00.37.153.517.517 0 00.2-.04.524.524 0 00.323-.484v-3.14A.524.524 0 0016.285 1z","transform":"translate(-2.809 1)","fill":"#6b7786"}})])])
          )
        }
      }
    